import * as React from "react";
import * as ReactDOM from "react-dom";
import * as Rest from "../../Generated/RestClient";
import { BotSettingsTabProps} from "./BotSettingsTab";
import {BotCodeSetupProps} from "./BotCodeSetup";
import {BotPageHeader} from "./BotPageHeader";
import {BotPageBody} from "./BotPageBody";
import {BotEditorProps} from "./BotEditor";
import {ChannelConfigInterface} from "./BotChannelConfig";
import {BotCodeEditorProps} from "./BotCodeEditor";
import {BotAppSettings} from "./BotAppSettings";
import {ControllerBase} from "../Controllers/ControllerBase";
import {Route} from "./BotPageHeader";
import { BotTypes, BotUtilsV2 } from '../../Utils/BotUtils';
import { Environment } from "../../../../Intercom.ReactUI/Utils/Environment";
import { IAnnouncements } from "../../DevPortalAppBase";
import { clientAppSettings } from "../../Models/ClientAppSettings";
import { getAzureIbizaBotUrl } from "../../Utils/Links";

export interface IconFile extends Blob {
    preview: string;
}

export interface SubscriptionsKeys {
    primary: string;
}

export function getDeploymentState(bot: Rest._BotService = {}): string {
    const deployment = bot.ProvisionInfo ? bot.ProvisionInfo.Deployment : {};
    return deployment && deployment.properties ? deployment.properties.provisioningState : null;
}

export function isDeploymentFinished(bot: Rest._BotService): boolean {
    const state = getDeploymentState(bot);
    const deployment = bot.ProvisionInfo ? bot.ProvisionInfo.Deployment : {};
    const pending = !bot.Endpoint && deployment && deployment.properties ? deployment.properties.intercom_pending_function_url : false;
    const finished = !pending && (state === "Succeeded" || state === "Failed");
    return finished;
}

export function isStillDeploying(bot: Rest._BotService = {}): boolean {
    return bot.ProvisionInfo && !isDeploymentFinished(bot);
}

// Must be kept in sync with resourceStrings.v4.botPageTabs
export enum BotTabs {
    Build,
    Analytics,
    Settings,
    Channels,
    Develop // for ABSv1 bot
}

export interface BotPageProps extends React.Props<BotPage> {
    controller: ControllerBase;
    botSettingsTabProps: BotSettingsTabProps;
    botEditorProps: BotEditorProps;
    botCodeEditorProps: BotCodeEditorProps;
    botCodeSetupProps: BotCodeSetupProps;
    tabClickHandler: (tab: BotTabs) => void;
    testClickHandler: () => void;
    importBotHandler: (file: any) => JQueryPromise<any>;
    channelConfigClickHandler: (toChannel: string) => void;
    channelConfigInterface: ChannelConfigInterface;
    initialBot: Rest.BotService;
    initialSelectedTab?: number;
    initialSubkeys: SubscriptionsKeys;
    initialShowWebChat: boolean;
    initialChannel?: string;
    initialAuthoringDirty?: boolean;
    initialAuthoringError?: boolean;
    onSetBotAppSettings(botAppSettings: BotAppSettings);
    scmType?: () => string;
    routes(botType: BotTypes): Route[];
    azureToken: string;
    canWriteToBot: boolean;
}

export interface BotPageState {
    bot?: Rest.BotService;
    subscriptionKeys?: SubscriptionsKeys;
    selectedTab?: number;
    showWebChat?: boolean;
    showWebChatPending?: boolean;
    authoringDirty?: boolean;
    authoringError?: boolean;
    reviewStatusDetail?: Rest.ReviewStatusDetail;
    channel?: string;
    announcements?: IAnnouncements;
}

export class BotPage extends React.Component<BotPageProps, BotPageState> {
    constructor(props?: BotPageProps, context?: any) {
        super(props, context);
        this.state = {
            bot: props.initialBot,
            subscriptionKeys: props.initialSubkeys,
            selectedTab: props.initialSelectedTab,
            showWebChat: props.initialShowWebChat,
            channel: props.initialChannel || "",
            authoringDirty: props.initialAuthoringDirty,
            authoringError: props.initialAuthoringError
        };
    }

    componentDidMount() {
        $('#page-content').scrollTop(0);
    }

    public render(): JSX.Element {
        const renderWebChat = !Environment.isInBotFrameworkAzureExtension;

        const isAdmin = this.props.controller.isAdminOrSupport();

        return (
            <div className="bot-page">
                <BotPageHeader
                    bot={ this.state.bot }
                    routes = {this.props.routes}
                    selectedTab={ this.state.selectedTab }
                    authoringToolDirty={this.state.authoringDirty}
                    showWebChat={this.state.showWebChat}
                    controller={this.props.controller}
                    isAdmin={this.props.botSettingsTabProps.isAdmin}
                    isReviewer={this.props.botSettingsTabProps.isReviewer}
                    tabClickHandler={ this.props.tabClickHandler }
                    testClickHandler={ this.props.testClickHandler }
                    importBotHandler={ this.props.importBotHandler }
                    announcements={this.state.announcements}
                />
                <BotPageBody
                    bot={ this.state.bot }
                    botSettingsTabProps={ this.props.botSettingsTabProps }
                    botEditorProps={this.props.botEditorProps}
                    botCodeEditorProps={this.props.botCodeEditorProps}
                    botCodeSetupProps={this.props.botCodeSetupProps}
                    authoringDirty={ this.state.authoringDirty }
                    authoringError={ this.state.authoringError }
                    tabClickHandler={ this.props.tabClickHandler }
                    selectedTab={ this.state.selectedTab }
                    renderWebChat={ renderWebChat }
                    showWebChat={ this.state.showWebChat }
                    showWebChatPending={this.state.showWebChatPending}
                    channel={ this.state.channel }
                    onSetBotAppSettings={this.props.onSetBotAppSettings}
                    channelConfigClickHandler={ this.props.channelConfigClickHandler }
                    channelConfigInterface={ this.props.channelConfigInterface }
                    azureToken={ this.props.azureToken}
                    canWriteToBot = { this.props.canWriteToBot }
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./Client/v4/Views/BotPage.tsx